// removed by extract-text-webpack-plugin
module.exports = {"docIcon":"_2Td7P","docLink":"_1GcKJ","docDate":"_3axvP"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/components/Sidebar/columns.scss
// module id = 729
// module chunks = 0